Object.defineProperty(exports,"__esModule",{value:true});var _reactNative=require('react-native');Object.keys(_reactNative).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _reactNative[key];}});});


// WEBPACK FOOTER //
// ./node_modules/@shoutem/ui/node_modules/react-native-vector-icons/dist/lib/react-native.js